/*
 * Copyright Evollis 2021
 * All Rights Reserved.
 *
 * All information contained herein is, and remains the property of Evollis.
 * The intellectual and technical concepts contained herein are
 * proprietary to Evollis and are protected by trade secret and copyright law.
 * Dissemination of this information or reproduction of this material
 * is STRICTLY FORBIDDEN unless prior written permission is obtained
 * from Evollis.
 */
import { loc } from "../../../core/utils"
import React from "react"
import { Button, Col, Row } from "react-bootstrap"

export default function SubmitButton({ disabled }) {
  return (
    <Row className="justify-content-center footer-fixed">
      <Col lg={3} md={3} sm={12}>
        <Button id="continue" variant="success" type="submit" className="btn-solid btn" disabled={disabled}>
          {loc`Validate`}
        </Button>
      </Col>
    </Row>
  )
}
